$(document).ready(function(){
	$(window).load(function(){
		// VARIABLES
		var $pageHeight = $(window).height(),
		$pageWidth = $(window).width(),
		$navHeight = $('header.main-header').outerHeight(),
		$footerHeight = $('footer.footer').outerHeight(),
		$mainWrapper = $('.wrapper-holder');

		var ajaxurl = $('.ajaxlocation').data('ajaxlocation');

		// INITIATIONS
		AOS.init();

		// CUSTOM FUNCTIONS
		carouselAnimation();
		tableClass();
		mobileLayout();
		wrapperHolder( $pageHeight, $navHeight, $footerHeight );
		cf7formsubmit();
		pageBanner( $navHeight );
		archiveProduct( $navHeight );
		masonryLayout();
		bullet();
		responsiveSlick();
		imageZoom();

		$('.loader-overlay').fadeOut(200);

		$(document).on('click', '.btn-search', function(){
			$(this).find('i').toggleClass('fa-times');
			$('.search-form').toggleClass('active');
		});

		$(document).on('change', '.location-selection', function(){
			var term_id = $(this).val();
			$.ajax({
				url : ajaxurl,
				type : 'POST',
				dataType: 'json',
				data : {
					action : 'request_locations',
					term_id: term_id
				},
				beforeSend: function(){
					$('.location-contain').html('<div class="message-warning">Loading...</div>');
				},
				success: function(response){
					$('.location-contain').html(response.locations);
					$('.rendering-locations').html(response.marker);
				}
			}); 
		});

		if( $('.archive-sidebar').length > 0 ) {
			$('.archive-sidebar ul li').each(function(){
				if( $(this).hasClass('active') ) {
					$(this).find('i').addClass('fa-angle-up');
				}
			});
		}

		$(document).on('click', '.side-btn', function(){
			$('.archive-sidebar ul li .side-btn i').removeClass('fa-angle-up');
			$(this).find('i').addClass('fa-angle-up');
			
			if( $(this).parent('li').hasClass('active') ) {
				$(this).find('i').removeClass('fa-angle-up');
				$(this).parent('li').removeClass('active');
			} else {
				$('.archive-sidebar ul li').removeClass('active');
				$(this).find('i').addClass('fa-angle-up');
				$(this).parent('li').addClass('active');
			}

		});

	});

	$(window).on('resize', function(){
		// VARIABLES
		var $pageHeight = $(window).height(),
		$pageWidth = $(window).width(),
		$navHeight = $('header.main-header').outerHeight(),
		$footerHeight = $('footer.footer').outerHeight(),
		$mainWrapper = $('.wrapper-holder');

		wrapperHolder( $pageHeight, $navHeight, $footerHeight );
		pageBanner( $navHeight );
		archiveProduct( $navHeight );
		setTimeout(function(){
			equalizer();
		}, 300);
		masonryLayout();

		if( Modernizr.mq('(min-width: 1200px)') ) {
			megaMenu();
		}

	});

});

/* MODERNIZR LAYOUT - This serves as the the media query inside the Javascript */
if( Modernizr.mq('(min-width: 1200px)') ) {
	megaMenu();
	equalizer();
}
else if( Modernizr.mq('(min-width: 992px)') && Modernizr.mq('(max-width: 1199px)') ) {
	equalizer();
}
else if( Modernizr.mq('(max-width: 991px)') && Modernizr.mq('(min-width: 768px)')){
	equalizer();
}
else{
	equalizer();
}

// FUNCTION LISTS
/*
* Method smooth scrolls to given anchor point
*/

function imageZoom(){
	var zoom = $('.image-container').data('zoom');
	var sample = $('.image-container').data('sample');
	var large = $('.image-container').data('large');
	$(".image-hover").html('<img id="wheel-zoom" alt="West Lake" src="'+zoom+'" data-zoom-image="'+large+'"/><img class="wheel-sample" alt="West Lake" src="'+sample+'">');
	$("#wheel-zoom").elevateZoom();
}
function smoothScrollTo(anchor) {
	var duration = 400; //time (milliseconds) it takes to reach anchor point
	var targetY = $(anchor).offset().top;
	$("html, body").animate({
		"scrollTop" : targetY
	}, duration, 'easeInOutCubic');
}

function carouselAnimation(){
	/* Demo Scripts for Bootstrap Carousel and Animate.css article
	* on SitePoint by Maria Antonietta Perna
	*/
  //Function to animate slider captions 
  function doAnimations( elems ) {
    //Cache the animationend event in a variable
    var animEndEv = 'webkitAnimationEnd animationend';
    
    elems.each(function () {
      var $this = $(this),
        $animationType = $this.data('animation');
      $this.addClass($animationType).one(animEndEv, function () {
        $this.removeClass($animationType);
      });
    });
  }
  
  //Variables on page load 
  var $myCarousel = $('.carousel'),
    $firstAnimatingElems = $myCarousel.find('.item:first').find("[data-animation ^= 'animated']");
      
  //Initialize carousel 
  $myCarousel.carousel();
  
  //Animate captions in first slide on page load 
  doAnimations($firstAnimatingElems);
  
  //Pause carousel  
  $myCarousel.carousel('pause');
  
  
  //Other slides to be animated on carousel slide event 
  $myCarousel.on('slide.bs.carousel', function (e) {
    var $animatingElems = $(e.relatedTarget).find("[data-animation ^= 'animated']");
    doAnimations($animatingElems);
  });

  $('.carousel').carousel();
}

function tableClass(){
	var $tables = $(document).find('table');
	if( $tables ) {
		$tables.wrap('<div class="table-responsive"></div>');
		$tables.addClass('table');
	}
}
function wrapperHolder( $pageHeight, $navHeight, $footerHeight ){
	$('.wrapper-holder').css({
		'min-height': $pageHeight - $navHeight,
		'padding-bottom': $footerHeight
	});
	$('.main-layout').css({
		'min-height': $pageHeight - ( $navHeight + $footerHeight ),
	});
}
function mobileLayout(){
	// MOBILE MENU LAYOUT
	$('.sidepanel .menu > .menu-item-has-children').addClass('dropdown row-size');
	$('.sidepanel .menu > .menu-item-has-children > a').each(function(){
		var $curr = $(this);
		$curr.addClass('column-top nav-title');
		$('<span class="fa fa-plus dropdown-toggle nav-control column-top" data-toggle="dropdown" style="min-height: '+ $curr.outerHeight() +'px;"></span>').insertAfter( $curr );			
	});
	$('.sidepanel .menu > .menu-item-has-children > .sub-menu').addClass('dropdown-menu');
	// MOBILE MENU
	if(!$('.sidepanel').hasClass('sidepanel-out')){
		$('.close-sidemenu').hide();
	}
	$('.mobile-menu-btn').click(function(){
		$('.sidepanel').toggleClass("sidepanel-out" );
		$(this).toggleClass('toggle-mobile-menu');
		if(!$('.sidepanel').hasClass('sidepanel-out')){
			$('.close-sidemenu').hide();
		} else {
			$('.close-sidemenu').show();
		}
	});
	$('.close-sidemenu').click(function(){
		$('.sidepanel').toggleClass("sidepanel-out");
		$(this).hide();
	});
	$('.sidepanel li a').click(function(){
		$(this).find('.fa-plus').toggleClass('fa-minus');
	});

	// BACK TO TOP
	$('.back-to-top').hide(); // HIDE ON FIRST LOAD
	$(window).scroll(function () {
		if ($(this).scrollTop() > 100) {
			$('.back-to-top').fadeIn();
		} else {
			$('.back-to-top').fadeOut();
		}
	});
	$('.back-to-top a').click(function () {
		$('body,html').animate({
			scrollTop: 0
		}, 800);
		return false;
	});

	$(document).on('click', '.mobile-menu-btn', function(){
		$('.menu-button').toggleClass('active');
	});
}

function cf7formsubmit(){
	var sitelink = $('.usd').data('usdacct');
	document.addEventListener( 'wpcf7mailsent', function( event ) {
	  location = sitelink + '/thank-you/';
	}, false );
}

function locations($country, $state, $city){
	// Sample Field
	// "select.csCountryOption", "select.csStateOption", "select.csCityOption"
	filter_country_state_city($country, $state, $city);
}

function objLightcase(){
	$('a[data-rel^=lightcase]').lightcase();
}

function responsiveSlick(){
	$('.slick-responsive').each(function(){
		var breaks = $(this).data('breakpoints').split('|'),
		breakArr = [],
		arrowsval;
		$.each(breaks, function(i, items){
			breakArr.push({
				breakpoint: parseInt(items.split(',')[0]),
	      settings: {
	        slidesToShow: parseInt(items.split(',')[1])
	      }
			});
		});
		if( $(this).data('arrows') ) {
			arrowsval = true;
		} else {
			arrowsval = false;
		}
		$(this).slick({
		  dots: false,
		  infinite: true,
		  speed: 300,
		  autoplay: true,
		  arrows: arrowsval,
		  slidesToShow: $(this).data('defaultview'),
		  slidesToScroll: 1,
		  adaptiveHeight: true,
		  asNavFor: $(this).data('thumb'),
		  responsive : breakArr,
		  prevArrow : '<button type="button" class="slick-prev slick-controller fa fa-angle-left"></button>',
		  nextArrow : '<button type="button" class="slick-next slick-controller fa fa-angle-right"></button>',
		});
	});
}

function megaMenu(){
	if( $('.custom-menu-btn').length > 0 ) {
		var menu_btn = $('.custom-menu-btn');
		if( $('.custom-menu').length > 0 ) {
			var mega_menu = $('.custom-menu');
			mega_menu.detach().appendTo(menu_btn);
		}
	}
}

function pageBanner(navheight){
	if( Modernizr.mq('(min-width: 1200px)') ) {
		$('.banner-container').css({
			'padding-bottom' : navheight - 100,
			'padding-top' : navheight + 75
		});
	}
	else if( Modernizr.mq('(min-width: 992px)') && Modernizr.mq('(max-width: 1199px)') ) {
		$('.banner-container').css({
			'padding-bottom' : navheight - 60,
			'padding-top' : navheight + 75
		});
	}
	else if( Modernizr.mq('(max-width: 991px)') && Modernizr.mq('(min-width: 768px)')){
		$('.banner-container').css({
			'padding-bottom' : navheight - 60,
			'padding-top' : navheight + 75
		});
	}
	else{
		$('.banner-container').css({
			'padding-bottom' : navheight - 40,
			'padding-top' : navheight + 75
		});
	}
}

function equalizer(){
	var maxHeight = 0;
	$(".equalize").each(function(){
	   if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
	});
	$(".equalize").height(maxHeight);

	var productHeight = 0;
	$(".hp-equalize").each(function(){
	   if ($(this).height() > productHeight) { productHeight = $(this).height(); }
	});
	$(".hp-equalize").height(productHeight);
}

function masonryLayout(){
	$('.grid').isotope({
	  itemSelector: '.grid-item',
	  percentPosition: true,
	  masonry: {
	    columnWidth: '.grid-item'
	  }
	});
}

function archiveProduct(navheight){
	if( Modernizr.mq('(min-width: 1200px)') ) {
		$('.products-archive').css({
			'padding-bottom' : 150,
			'padding-top' : navheight + 150
		});
	}
	else if( Modernizr.mq('(min-width: 992px)') && Modernizr.mq('(max-width: 1199px)') ) {
		$('.products-archive').css({
			'padding-bottom' : 45,
			'padding-top' : navheight + 45
		});
	}
	else if( Modernizr.mq('(max-width: 991px)') && Modernizr.mq('(min-width: 768px)')){
		$('.products-archive').css({
			'padding-bottom' : 35,
			'padding-top' : navheight + 35
		});
	}
	else{
		$('.products-archive').css({
			'padding-bottom' : 25,
			'padding-top' : navheight + 25
		});
	}
}

function bullet(){
	$('.listing-styled ul li').each(function(){
		$(this).prepend('<i class="fas fa-check"></i>');
	});
}